import { useBrandColors } from '../../hooks/useBrandColors'

export default function Documents() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const docs = [
    { title: 'Employee Handbook 2025 — Signed', meta: 'Signed Jan 12, 2025 · PDF · 2.4 MB', status: 'Signed', statusColor: '#4A7C59' },
    { title: 'I-9 Employment Eligibility Verification', meta: 'Completed Jan 12, 2023 · PDF · 0.8 MB', status: 'On File', statusColor: '#4A7C59' },
    { title: 'Offer Letter — Signed', meta: 'Signed Jan 8, 2023 · PDF · 0.5 MB', status: 'Signed', statusColor: '#4A7C59' },
    { title: 'Safety Training Certificate — Module 1 & 2', meta: 'Completed Mar 15, 2025 · PDF · 1.1 MB', status: 'Active', statusColor: accent },
    { title: 'Direct Deposit Authorization', meta: 'Submitted Jan 12, 2023 · PDF · 0.3 MB', status: 'On File', statusColor: '#4A6B8A' },
    { title: 'Updated Parking Policy — Acknowledgment', meta: 'Issued Mar 25, 2025 · Pending signature', status: 'Pending', statusColor: '#A0392B' },
  ]

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>My Documents</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Your personal file library — policies, forms, and certifications</p>
        </div>
      </div>

      <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
        <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Employee Documents</div>
          <span style={{padding:'2px 8px',borderRadius:8,fontSize:10,fontWeight:600,background:'rgba(160,57,43,0.1)',color:'#A0392B'}}>1 pending signature</span>
        </div>
        {docs.map((d,i) => (
          <div key={i} style={{display:'flex',alignItems:'center',gap:14,padding:'14px 16px',borderBottom:i<docs.length-1?'1px solid #EDE6DA':'none',cursor:'pointer'}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(184,115,74,0.04)'}
            onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
            <div style={{width:36,height:36,borderRadius:8,background:d.statusColor+'22',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="3" y="2" width="12" height="14" rx="2" stroke={d.statusColor} strokeWidth="1.25"/><path d="M6 7h6M6 10h4" stroke={d.statusColor} strokeWidth="1.25" strokeLinecap="round"/></svg>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:500,color:'#2B2B2B',marginBottom:2}}>{d.title}</div>
              <div style={{fontSize:11,color:'#8A9E8A'}}>{d.meta}</div>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:11,fontWeight:600,color:d.statusColor}}>
                {d.status === 'Signed' || d.status === 'On File' || d.status === 'Active' ? '✓ ' : '! '}{d.status}
              </span>
              <button style={{padding:'5px 10px',border:'1px solid #EDE6DA',borderRadius:5,background:'#fff',fontSize:11,color:'#6B7D6B',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                View
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

